var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16.637a15.895 15.895 0 1 1 31.79 0 15.895 15.895 0 0 1-31.79 0zM15.895 3.022a13.615 13.615 0 1 0 0 27.23 13.615 13.615 0 0 0 0-27.23zm1.8 20.815a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0zm-5.28-10.2c0-1.627 1.404-3.18 3.48-3.18s3.48 1.553 3.48 3.18c0 1.179-.648 1.781-1.766 2.46-.123.077-.267.159-.423.25-.469.26-.92.548-1.353.864-.581.451-1.258 1.183-1.258 2.306a1.32 1.32 0 0 0 2.64.01c.067-.09.148-.17.24-.235.245-.19.516-.346.879-.557.187-.108.4-.233.648-.382 1.281-.78 3.033-2.066 3.033-4.716 0-3.172-2.676-5.82-6.12-5.82s-6.12 2.648-6.12 5.82a1.32 1.32 0 0 0 2.64 0z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.99a857a29601b9cd3b61ecfdc1a1a23f.svg";
export { ForwardRef as ReactComponent };